import {
  User,
  CloudDownload,
  Printer,
  Sparkles,
  FileText,
  MessageSquareText,
  Phone,
  Calendar,
  Stethoscope,
  History,
} from 'lucide-react';
import React, { useEffect, useRef, useState} from 'react';
import Select from "react-select";
import Badge from '../UI/Badge';
import SearchForm from '../UI/SearchForm';
import Spacing from '../Spacing';
import Accordion from '../UI/Accordion';
import { fetchSinglePatient, addPatients } from "../../services/patient";
import { calculateAgeFromDOB, can_visit, caregap_name, exchangeDate, notify, sortCaregapsData, usPhoneFormat } from "../../helpers";
import Inputmask from 'inputmask';
import QualityMeasureMessageModal from './QualityMeasureMessageModal';
import PatientCareGapViewModal from './PatientCareGapViewModal';
import PatientOutReachModal from './PatientOutreachModal';
import { Drawer } from 'vaul';

export default function PatientSingleViewModal(props) {
  // const location_id = getPractice("location_id");
  // const account_id = getPractice("account_id");
  
  const [messageActiveModal, setMessageActiveModal] = useState(false);
  const [activePatientViewCareGapModal, setActivePatientViewCareGapModal] = useState(false);  
  const [patientData, setPatientData] = useState({});
  const [activeTab, setActiveTab] = useState(0);  
  const [changeData, setChangeData] = useState(false);  
  const [data, setData] = useState([]);
  const [filteredConditions, setFilteredConditions] = useState([]);
  const {    
    patient_id = "",
    reloadData = () => {},
    reloadDataFilter = {},
    messageTemplate = [],
    account_id,
    location_id,
    insuranceOptions,
    activeModal,
    setActiveModal = () => {},
    setSmsLimit = () => {},
    outreachOpen = false,
    setOutreachOpen = () => {},
    startSchedular = false,
    setStartSchedular = () => {},
    callNoteCallType,
    setCallNoteCallType = () => {},
    setActiveCallNoteCallModal = () => {},
    callId,
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
    setPreviousCallScrollPosition = () => {},
  } = props;

  const [opacityClass, setOpacityClass] = useState("");
  const dropdownRef = useRef(null);
  
  useEffect(() => {
    if(outreachOpen && startSchedular) {
      setActiveTab(3);
    }
  }, [outreachOpen, startSchedular]);

  const loadData = async (account_id, location_id, patient_id) => {
    const response = await fetchSinglePatient(
      account_id,
      location_id,
      patient_id
    );
    if (response) {
      if(response.data === null) {
        notify("error", "Something went wrong", 0.5);
        setActiveModal(!activeModal);
        window.scrollTo(0, previousScrollPosition);
        return;
      }
      setData(response.data);
      BulkHandleChange(response.data);

      if (
        response?.data?.chronic_conditions &&
        response?.data?.chronic_conditions.length > 0
      ) {
        handleFilterConditions(response?.data?.chronic_conditions);
      }
    }
  };

  const modalStatus = (status) => {   
    setActiveModal(status);
    if (status) { 
      loadData(account_id, location_id, patient_id);
    }
  };

  const defaultValues = {
    account_id: account_id,
    location_id: location_id,
    first_name: "",
    last_name: "",
    dob: "",
    sex: "M",
    mobile_phone: "",
    home_phone: "",
    email: "",
    address: "",
    city: "",
    zip: "",
    state: "",
    insurance_id: 1,
    insurance_code: "",
    risk_level: "",
    last_visit: "",
    colorectal_cs_time_period_months: 12,
  };

  const [formData, setFormData] = useState(defaultValues);

  const allInsuranceOptions = insuranceOptions?.map((option) => ({
    value: option?.id,
    label: option?.name,
  }));

  const handleInsuranceChange = (selectedOption) => {
    setChangeData(true);
    setFormData({ ...formData, insurance_id: selectedOption?.value || "" });
  };

  const handleChange = (e) => { 
    setChangeData(true);   
    const { name, value } = e.target; 
    if (name === "mobile_phone") {               
      const phoneInputs = document.querySelectorAll('.us_phone');
      Inputmask({
          mask: '(999) 999-9999',
          showMaskOnHover: false,
          showMaskOnFocus: true,
      }).mask(phoneInputs);
    }
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const BulkHandleChange = (db_data) => {
    const newData = {};
    Object.keys(defaultValues).forEach(key => {
      let value = "";     

      // let lastVisit = careGapsLatestCompletedDos(db_data?.care_gaps);        
      if (key === "insurance_id") { 
        value = db_data?.insurance.id;         
      } else if (key === "risk_level") { 
        value = db_data?.risk_level; 
      } else { 
        value = db_data[key]; 
      }   
      if (key === "mobile_phone") {
        if (value === null) {
          value = db_data["home_phone"];
        } 
        const phoneInputs = document.querySelectorAll('.us_phone');
        Inputmask({
            mask: '(999) 999-9999',
            showMaskOnHover: false,
            showMaskOnFocus: true,
        }).mask(phoneInputs);
      }
      if (value === null) { 
        value = "";
      }     
      newData[key] = value; // Collect key-value pairs in newData
    });
    // Update formData once with all the collected data
    setFormData(newData);

};

  useEffect(() => {
    setFormData({
      ...formData,
      location_id: location_id,
      account_id: account_id,
    })
    modalStatus(activeModal)
  }, [location_id, account_id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
   
    e.target.disabled = true;
    const response = await addPatients(formData);
     
    if (response.detail) {
      notify('error', response.detail);
    } else { 
      reloadData(reloadDataFilter);
      notify("success", response?.data?.message);
      // setActiveModal(!activeModal);
      // window.scrollTo(0, previousScrollPosition);
    } 
    e.target.disabled = false;   

  };

  const handleFilterConditions = (chronicConditions) => {
    const filteredData = chronicConditions.reduce((acc, condition) => {
      const diseaseOrName = condition?.disease_name || condition?.name || "";

      const isType2DiabetesIncluded = acc.some(c => 
        c?.disease_name?.includes("Type 2 Diabetes") || c?.name?.includes("Type 2 Diabetes")
      );

      if (!isType2DiabetesIncluded || !diseaseOrName.includes("Type 2 Diabetes")) {
        acc.push({
          ...condition,
          name: diseaseOrName.includes("Type 2 Diabetes") ? "Type 2 Diabetes" : diseaseOrName,
        });
      }
  
      return acc;
    }, []);

    setFilteredConditions(filteredData);
  };

  const [viewStatusOptions, setViewStatusOptions] = useState(false);
  const handleOutsideClick = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setViewStatusOptions(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleDropdownClick = () => {
    setViewStatusOptions(!viewStatusOptions);
  };

  const handleCall = (callType) => {
    setCallNoteCallType(callType);
    setActiveCallNoteCallModal(true);
    setViewStatusOptions(false);
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
    setPreviousCallScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };

  const handleSendMessageModal = (data) => {
    setPatientData(data)
    setMessageActiveModal(!messageActiveModal);
    setOpacityClass("docpro_opaciry_0");
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleViewHistoryModal = () => {
    setActivePatientViewCareGapModal(!activePatientViewCareGapModal);
    setOpacityClass("docpro_opaciry_0");
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleDrawerClose = () => {
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <>
      <div style={{ height: "100%" }} ref={dropdownRef}>
        <Drawer.Root open={activeModal} onOpenChange={setActiveModal} onClose={handleDrawerClose}>
          <Drawer.Trigger className="docpro_single_patiant_modal_btn">
          </Drawer.Trigger>
          <Drawer.Portal>
            <Drawer.Overlay className="docpro_drawer_overlay"/>
            <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
              <Drawer.Title className="sr-only">Patient Details</Drawer.Title>
              <Drawer.Description className="sr-only">View details of a parient</Drawer.Description>
              <div className={`docpro_modal_wrap docpro_style_1 docpro_modal_lg ${opacityClass}`}>
                <div className="docpro_modal" style={{ backgroundColor: '#F9F9FB' }}>
                  {data?.length === 0 ? (
                    <div
                      style={{
                        height: "300px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Loading...
                    </div>
                  ) : (
                    <>
                      <form onSubmit={handleSubmit}>
                        <div className="docpro_patient_head" style={{ alignItems: "start" }}>
                          <div className="docpro_media">
                            <img src="/images/avatar.png" alt="Avatar" />
                            <div className="docpro_media_right">
                              <h2 className="docpro_fs_24">
                                {data?.last_name + " " + data?.first_name}
                              </h2>

                              {data?.risk_level === "High" && (
                                <Badge color="red">
                                  <span>High-Risk Patient</span>{" "}
                                </Badge>
                              )}
                              {data?.risk_level === "Moderate" && (
                                <Badge color="orange">
                                  <span>Moderate-Risk Patient</span>
                                </Badge>
                              )}
                              {data?.risk_level === "Low" && (
                                <Badge color="green">
                                  <span>Low-Risk Patient</span>
                                </Badge>
                              )}
                              <p
                                className="docpro_fs_16 docpro_primary_color"
                                style={{ paddingLeft: "5px" }}
                              >
                                {" "}
                                Gender: {formData?.sex === "M" ? "Male" : formData?.sex === "F" ? "Female" : "Other"}{" "}
                                <span className="docpro_white_color">--</span> Age:{" "}
                                {data.dob ? calculateAgeFromDOB(data.dob)+"Y" : ""}
                              </p>
                            </div>
                          </div>
                          <div className="docpro_bordered_btns">
                            {/* <MessageModal
                              last_name={data?.last_name}                    
                              first_name={data?.first_name}                    
                              phone={data?.mobile_phone} 
                              class_name="docpro_icon_btn_2 docpro_primary_color"
                            /> */}

                            {/* <button
                              className="docpro_icon_btn_2 docpro_primary_color"
                              type="button"
                            >
                              <CloudDownload />
                            </button>
                            <button
                              className="docpro_icon_btn_2 docpro_primary_color"
                              type="button"
                            >
                              <Printer />
                            </button> */}
                            {/* <div className="flex items-center"> */}
                              {can_visit("_call_note") && (
                                <div className="dropdown-container relative">
                                  <button
                                    type='button'
                                    className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                                    onClick={() => handleDropdownClick()}
                                  >
                                    <Phone width={17} height={17} />
                                    <span>Call this patient</span>
                                  </button>
                                  {viewStatusOptions && (
                                    <div className={`docpro_button_toggle_options call_note_dropdown`}>
                                      <p>Reason for call</p>
                                      {filteredConditions && filteredConditions.length > 0 && (
                                        <button type='button' onClick={() => handleCall('ccm')}>
                                          <Stethoscope width={15} height={15} className='mr-2' />
                                          <span>CCM</span>
                                        </button>
                                      )}
                                      <button type='button' onClick={() => handleCall('scheduling')}>
                                        <Calendar width={15} height={15} className='mr-2' />
                                        <span>Schedule</span>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              )}
                            {/* </div> */}
                          </div>
                        </div>
                        <Spacing lg="20" sm="20" />
                        <div className="docpro_tab items-center justify-between">
                          <div>
                            <button
                              type="button"
                              className={`docpro_tab_item ${
                                activeTab === 0 ? "active" : ""
                              }`}
                              onClick={() => {
                                setActiveTab(0);
                                setStartSchedular(false);
                              }}
                            >
                              <User width={15} height={15} /> Patient Info
                            </button>
                            {/* <button
                              type="button"
                              className={`docpro_tab_item ${
                                activeTab === 1 ? "active" : ""
                              }`}
                              onClick={() => {
                                setActiveTab(1);
                                setStartSchedular(false);
                              }}
                            >
                              <FileText width={15} height={15} /> Consult Note (2)
                            </button>
                            <button
                              type="button"
                              className={`docpro_tab_item ${
                                activeTab === 2 ? "active" : ""
                              }`}
                              onClick={() => {
                                setActiveTab(2);
                                setStartSchedular(false);
                              }}
                            >
                              <Sparkles width={15} height={15} /> AI Charting
                            </button> */}
                            {can_visit('_call_note') && (
                              <button
                                type="button"
                                className={`docpro_tab_item ${
                                  activeTab === 3 ? "active" : ""
                                }`}
                                onClick={() => {
                                  setActiveTab(3);
                                  setStartSchedular(false);
                                }}
                              >
                                <Phone width={15} height={15} /> Outreach
                              </button>
                            )}
                          </div>
                          {(activeTab !== 3 && can_visit("patient_database_create_patient")) && (
                            <button
                              type="submit"
                              className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                              disabled={!changeData ? true : false}
                            >
                              Save
                            </button>
                          )}
                        </div>
                        <hr />
                        <Spacing lg="20" sm="20" />
                        {activeTab === 0 && (
                          <>
                            <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3 input">
                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 ">
                                  Last Name{" "}
                                  <span className="docpro_red_color">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="docpro_form_field size_lg"
                                  name="last_name"
                                  required
                                  readOnly
                                  defaultValue={formData?.last_name}
                                />
                              </div>
                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 ">
                                  First Name{" "}
                                  <span className="docpro_red_color">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="docpro_form_field size_lg"
                                  name="first_name"
                                  required
                                  readOnly
                                  defaultValue={formData?.first_name}
                                />
                              </div>
                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 ">
                                  Date of Birth{" "}
                                  <span className="docpro_red_color">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="docpro_form_field size_lg"
                                  name="dob"
                                  placeholder="mm/dd/yyyy"
                                  required
                                  readOnly
                                  defaultValue={exchangeDate(formData?.dob)}
                                />
                              </div>

                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 ">
                                  Phone <span className="docpro_red_color">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="docpro_form_field size_lg us_phone"
                                  name="mobile_phone"
                                  required
                                  readOnly
                                  defaultValue={formData?.mobile_phone}
                                  maxLength={20}
                                  placeholder="(123) 123 1234"
                                />
                              </div>
                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 ">
                                  Last Visit{" "}
                                  <span className="docpro_red_color">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="docpro_form_field size_lg"
                                  placeholder="mm/dd/yyyy"
                                  required
                                  readOnly
                                  defaultValue={exchangeDate(formData?.last_visit)}
                                />
                              </div>

                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 docpro_primary_color">
                                  Email
                                </label>
                                <input
                                  type="email"
                                  className="docpro_form_field size_lg"
                                  name="email"
                                  onChange={handleChange}
                                  value={formData?.email}
                                />
                              </div>

                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 docpro_primary_color">
                                  Address
                                </label>
                                <input
                                  type="text"
                                  className="docpro_form_field size_lg"
                                  name="address"
                                  onChange={handleChange}
                                  value={formData?.address}
                                />
                              </div>

                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 docpro_primary_color">
                                  City
                                </label>
                                <input
                                  type="text"
                                  className="docpro_form_field size_lg"
                                  name="city"
                                  onChange={handleChange}
                                  value={formData?.city}
                                />
                              </div>
                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 docpro_primary_color">
                                  Zip
                                </label>
                                <input
                                  type="text"
                                  className="docpro_form_field size_lg"
                                  name="zip"
                                  onChange={handleChange}
                                  value={formData?.zip}
                                />
                              </div>
                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 docpro_primary_color">
                                  State
                                </label>
                                <input
                                  type="text"
                                  className="docpro_form_field size_lg"
                                  name="state"
                                  onChange={handleChange}
                                  value={formData?.state}
                                />
                              </div>

                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 docpro_primary_color">
                                  Insurance Name{" "}
                                  <span className="docpro_red_color">*</span>
                                </label>
                                <Select
                                  required
                                  name="insurance_id"
                                  options={allInsuranceOptions}
                                  placeholder="Search..."
                                  isSearchable
                                  value={allInsuranceOptions?.find((option) => option?.value === formData?.insurance_id) || null}
                                  onChange={handleInsuranceChange}
                                  className="react-select-container w-full"
                                  classNamePrefix="react-select"
                                  filterOption={(option, rawInput) => {
                                    const words = rawInput.toLowerCase().split(" ");
                                    return words.every((word) =>
                                      option.label.toLowerCase().includes(word)
                                    );
                                  }}
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: '40px',
                                      borderColor: 'var(--border)',
                                      borderRadius: '8px'
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      zIndex: 1050,
                                      marginTop: '-2px',
                                      borderRadius: '0 0 3px 3px',
                                    }),
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 1050,
                                      padding: 0
                                    }),
                                  }}
                                />
                                {/* <select
                                  className="docpro_form_field size_lg"
                                  name="insurance_id"
                                  value={formData?.insurance_id}
                                  onChange={handleChange}
                                >
                                  {insuranceOptions.map((insurance) => (
                                    <option key={insurance.id} value={insurance.id}>
                                      {insurance.name}
                                    </option>
                                  ))}
                                </select> */}
                              </div>
                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 docpro_primary_color">
                                  Insurance ID
                                </label>
                                <input
                                  type="text"
                                  className="docpro_form_field size_lg"
                                  name="insurance_code"
                                  onChange={handleChange}
                                  value={formData?.insurance_code}
                                />
                              </div>
                            </div>
                            {/* <Spacing lg="20" sm="20" />
                            <div className="docpro_radio_with_text" >
                              <label> Colorectal Cancer Screening: </label>
                              <input
                                type="number"
                                min={1}
                                max={120}
                                name="colorectal_cs_time_period_months"
                                className="docpro_form_field size_lg"
                                onChange={handleChange}
                                value={formData?.colorectal_cs_time_period_months !== '' ? formData?.colorectal_cs_time_period_months : 12}
                              />
                              months
                            </div> */}

                            <Spacing lg="36" sm="36" />
                            <hr />
                            <Spacing lg="36" sm="36" />
                            <div className="flex justify-between">
                              <h3 className="docpro_fs_18 docpro_mb_0">Care gap</h3>
                              <button
                                className="docpro_bordered_btn docpro_fw_600 docpro_primary_color docpro_icon_btn last_btn_tip overview"
                                type="button"
                                onClick={handleViewHistoryModal}
                                style={{
                                  width: "auto",
                                  border: "1px solid #b9bbc6",
                                  padding: "5px 12px",
                                  color: "var(--primary)"
                                }}
                              >
                                <History
                                  width={20}
                                  height={20}
                                />
                                View History
                                <div className="docpro_tip">
                                  <span>
                                    View Patient Care Gaps <br /> Completed History
                                  </span>
                                </div>
                              </button>
                            </div>
                            <Spacing lg="12" sm="12" />
                            <div className="docpro_table_1">
                              <div className="docpro_table_responsive">
                                <table className="docpro_mb_0 docpro_primary_color">
                                  <thead>
                                    <tr>
                                      <th>Quality Measure </th>
                                      <th>Status</th>
                                      <th>Completion Date</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data?.care_gaps && data?.care_gaps.length > 0 ? (
                                      sortCaregapsData(data.care_gaps).map(
                                        (item, index) => (
                                          <tr key={index}>
                                            <td>{caregap_name(item.care_gap_id)}</td>
                                            <td>
                                              {item.status === "pending" ? (
                                                <Badge color="orange">Pending</Badge>
                                              ) : (
                                                <Badge color="green">Done</Badge>
                                              )}
                                            </td>
                                            <td>
                                              {" "}
                                              {item.status === "pending" ? (
                                                <>-</>
                                              ) : (
                                                <>{exchangeDate(item.dos)}</>
                                              )}
                                            </td>
                                            <td>
                                              {(item.status === "pending" && can_visit('_single_message')) ? (
                                                <button
                                                  type="button"
                                                  className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
                                                  onClick={() =>
                                                    handleSendMessageModal(item)
                                                  }
                                                >
                                                  <MessageSquareText
                                                    width={20}
                                                    height={20}
                                                  />
                                                  Send SMS
                                                </button>
                                              ) : (
                                                <></>
                                              )}
                                            </td>
                                          </tr>
                                        )
                                      )
                                    ) : (
                                      <tr>
                                        <td className="no_data" colSpan="4">
                                          No data available
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <Spacing lg="36" sm="36" />
                            <h3 className="docpro_fs_18 docpro_mb_0">
                              Chronic conditions{" "}
                              <span className="docpro_fw_400">
                                ({filteredConditions && filteredConditions.length})
                              </span>
                            </h3>
                            <Spacing lg="12" sm="12" />
                            {/* <div className="docpro_grid docpro_grid_col_6 docpro_grid_gap_2">
                              {data?.chronic_conditions &&
                              data?.chronic_conditions.length > 0 ? (
                                data?.chronic_conditions?.map(
                                  (item, index) => (
                                    <div className="docpro_grid_item" key={item.id}>
                                      <div className="docpro_border_box">
                                        {item.name}
                                      </div>
                                    </div>
                                  )
                                )
                              ) : (
                                <div className="no_data">No data available</div>
                              )}
                            </div> */}

                            <div className="docpro_grid docpro_grid_col_6 docpro_grid_gap_2">
                              {filteredConditions && filteredConditions.length > 0 ? (
                                filteredConditions.map((item) => (
                                  <div className="docpro_grid_item" key={item.id}>
                                    <div className="docpro_border_box">
                                      {item.name}
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="no_data">No data available</div>
                              )}
                            </div>
                          </>
                        )}
                        {activeTab === 1 && (
                          <>
                            <div className="docpro_table_1">
                              <div className="docpro_table_responsive">
                                <table className="docpro_mb_0 docpro_primary_color">
                                  <thead>
                                    <tr>
                                      <th style={{ width: "35%" }}>
                                        Quality Measure{" "}
                                      </th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody className="docpro_vertical_align">
                                    <tr>
                                      <td>
                                        <ul className="docpro_list_1">
                                          <li>
                                            <b>Doctor:</b> Mr Doctor
                                          </li>
                                          <li>
                                            <b>Practice Name:</b> Medical Care
                                          </li>
                                          <li>
                                            <b>Address:</b> New York
                                          </li>
                                          <li>
                                            <b>Specialty:</b>{" "}
                                            <Badge color="cyan" square>
                                              Acupuncturist
                                            </Badge>
                                          </li>
                                          <li>
                                            <b>Referral Date:</b> 12/03/2012
                                          </li>
                                        </ul>
                                      </td>
                                      <td>
                                        <div className="docpro_textarea_1">
                                          Patient: Jhon Doe DOB: 01/01/1980 Date of
                                          Consult: 03/09/2024 <br />
                                          Reason for Consult: The patient was referred
                                          by her primary care provider, Dr. Smith, for
                                          evaluation and management of persistent low
                                          back pain. History of Present Illness: Jhon
                                          Doe is a 44-year-old female who has been
                                          experiencing low back pain for the past 3
                                          months. The pain is located in the lumbar
                                          region and radiates down her right leg. She
                                          describes the pain as a dull ache that
                                          worsens with prolonged standing or sitting.
                                          The pain has been interfering with her daily
                                          activities and sleep. She has tried
                                          over-the-counter pain medication and
                                          heat/ice therapy with minimal relief. <br />
                                          Past Medical History: <br />
                                          <ul>
                                            <li>
                                              Hypertension, well-controlled on
                                              lisinopril
                                            </li>
                                            <li>
                                              No history of prior back injuries or
                                              surgeries
                                            </li>
                                          </ul>
                                          Physical Examination: <br />
                                          <ul>
                                            <li>
                                              Vital signs: BP 128/82, HR 72,
                                              Respiratory Rate 14, Temperature 98.6°F
                                            </li>
                                            <li>
                                              Musculoskeletal: Tenderness to palpation
                                              over the right lumbar paraspinal
                                              muscles. Decreased range of motion in
                                              forward flexion, with pain. Positive
                                              straight leg raise test on the right
                                              side.
                                            </li>
                                            <li>
                                              Neurological: Intact sensation,
                                              strength, and deep tendon reflexes in
                                              the lower extremities.
                                            </li>
                                          </ul>
                                          Impression: Based on the history and
                                          physical examination, the patient appears to
                                          be suffering from right-sided lumbar
                                          radiculopathy, likely secondary to a disc
                                          herniation at the L4-L5 level. <br />
                                          Recommendations: <br />
                                          <ol>
                                            <li>
                                              Start a course of oral anti-inflammatory
                                              medication (e.g., ibuprofen 600 mg TID)
                                              and continue with conservative
                                              management, including physical therapy
                                              and home exercise program.
                                            </li>
                                            <li>
                                              If symptoms do not improve within 4-6
                                              weeks, order an MRI of the lumbar spine
                                              to further evaluate the underlying
                                              cause.
                                            </li>
                                            <li>
                                              Follow up with me in 4-6 weeks to assess
                                              response to treatment. Please let me
                                              know if you have any other questions or
                                              concerns. Sincerely, Dr. Jane Specialist
                                              Orthopedic Spine Surgeon
                                            </li>
                                          </ol>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </>
                        )}
                        {activeTab === 2 && (
                          <>
                            <label className="docpro_fw_500 docpro_primary_color">
                              Patient Info
                            </label>
                            <div className="docpro_sp_section_1 docpro_primary_color">
                              <div>
                                <div className="docpro_table_1">
                                  <div className="docpro_table_responsive">
                                    <table className="docpro_mb_0 docpro_primary_color">
                                      <tbody className="docpro_vertical_align">
                                        <tr>
                                          <td
                                            className="docpro_fw_500"
                                            style={{ width: "35%", borderTop: "0px" }}
                                          >
                                            First Name
                                          </td>
                                          <td style={{ borderTop: "0px" }}>Diaz</td>
                                        </tr>
                                        <tr>
                                          <td
                                            className="docpro_fw_500"
                                            style={{ width: "35%" }}
                                          >
                                            Last Name
                                          </td>
                                          <td>Angelisa</td>
                                        </tr>
                                        <tr>
                                          <td
                                            className="docpro_fw_500"
                                            style={{ width: "35%" }}
                                          >
                                            DOB
                                          </td>
                                          <td>12/23/1992</td>
                                        </tr>
                                        <tr>
                                          <td
                                            className="docpro_fw_500"
                                            style={{ width: "35%" }}
                                          >
                                            Phone
                                          </td>
                                          <td>+3451231234</td>
                                        </tr>
                                        <tr>
                                          <td
                                            className="docpro_fw_500"
                                            style={{ width: "35%" }}
                                          >
                                            Insurance
                                          </td>
                                          <td>Blue Cross Blue Shield</td>
                                        </tr>
                                        <tr>
                                          <td
                                            className="docpro_fw_500"
                                            style={{ width: "35%" }}
                                          >
                                            Insurance ID
                                          </td>
                                          <td>567845</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <label className="docpro_fw_500 docpro_primary_color">
                                  Referral
                                </label>
                                <div className="docpro_radio_group">
                                  <div className="docpro_radio">
                                    <input type="radio" name="referral" />
                                    <label style={{ paddingLeft: "30px" }}>Yes</label>
                                  </div>
                                  <div className="docpro_radio">
                                    <input type="radio" name="referral" />
                                    <label style={{ paddingLeft: "30px" }}>No</label>
                                  </div>
                                </div>
                                <Spacing lg="20" sm="20" />
                                <label className="docpro_fw_500 docpro_primary_color">
                                  Medication
                                </label>
                                <div className="docpro_radio_group">
                                  <div className="docpro_radio">
                                    <input type="radio" name="medication" />
                                    <label style={{ paddingLeft: "30px" }}>Yes</label>
                                  </div>
                                  <div className="docpro_radio">
                                    <input type="radio" name="medication" />
                                    <label style={{ paddingLeft: "30px" }}>No</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Spacing lg="36" sm="36" />
                            <label className="docpro_fw_500 docpro_primary_color">
                              Visit type
                            </label>
                            <select className="docpro_form_field size_lg">
                              <option value="1">DOT Physical</option>
                              <option value="2">DOT Physical</option>
                              <option value="3">DOT Physical</option>
                              <option value="4">DOT Physical</option>
                            </select>
                            <Spacing lg="16" sm="16" />
                            <label className="docpro_fw_500 docpro_primary_color">
                              Reason for visit
                            </label>
                            <SearchForm variant="size_lg" />
                            <Accordion title="Abdomainal Distension (Gaseous)">
                              <div className="docpro_grid docpro_grid_gap_20 docpro_grid_col_2">
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    Duration
                                  </label>
                                  <div className="docpro_form_field_group">
                                    <input
                                      type="text"
                                      className="docpro_form_field size_lg"
                                    />
                                    <select className="docpro_form_field size_lg">
                                      <option value={1}>Days</option>
                                      <option value={2}>1</option>
                                      <option value={3}>2</option>
                                      <option value={4}>3</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    Onset
                                  </label>
                                  <select className="docpro_form_field size_lg">
                                    <option value="1">Onset</option>
                                    <option value="2">Onset 1</option>
                                    <option value="3">Onset 2</option>
                                  </select>
                                </div>
                              </div>
                              <Spacing lg="20" sm="20" />
                              <textarea
                                cols="30"
                                rows="2"
                                className="docpro_form_field"
                              ></textarea>
                            </Accordion>
                          </>
                        )}
                        {(activeTab === 3 && can_visit('_call_note')) && (
                          <>
                            <PatientOutReachModal 
                              patient_id={patient_id}
                              account_id={account_id}
                              location_id={location_id}
                              startSchedular={startSchedular}
                              setStartSchedular={setStartSchedular}
                              last_name={formData?.last_name}
                              first_name={formData?.first_name}
                              dob={formData?.dob}
                              callId={callId}
                              callNoteCallType={callNoteCallType}
                            />
                          </>
                        )}
                      </form>
                    </>
                  )}
                </div>
              </div>
            </Drawer.Content>
          </Drawer.Portal>
        </Drawer.Root>
      </div>

      {messageActiveModal && (
        <QualityMeasureMessageModal
          patient_id={patient_id}
          last_name={formData?.last_name}
          first_name={formData?.first_name}
          phone={usPhoneFormat(formData?.mobile_phone)}
          template_type={patientData?.name}
          messageTemplate={messageTemplate}
          account_id={account_id}
          location_id={location_id}
          activeModal={messageActiveModal}
          setActiveModal={setMessageActiveModal}
          setSmsLimit={setSmsLimit}
          setOpacityClass={setOpacityClass}
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {activePatientViewCareGapModal && (
        <PatientCareGapViewModal
          account_id={account_id}
          location_id={location_id}
          patient_id={patient_id}
          age={calculateAgeFromDOB(data?.dob)}
          gender={data?.sex}
          last_visit={data?.last_visit}
          activeModal={activePatientViewCareGapModal}
          setActiveModal={setActivePatientViewCareGapModal}
          setOpacityClass={setOpacityClass}
          previousScrollPosition={previousScrollPosition}
        />
      )}
    </>
  );
}